module.exports = __webpack_public_path__ + "static/img/11.e65d8e6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/3/sp/11.png
// module id = kF1m
// module chunks = 0